import { render } from "./CorporateGovernance.vue?vue&type=template&id=27b69fda&scoped=true"
import script from "./CorporateGovernance.vue?vue&type=script&lang=js"
export * from "./CorporateGovernance.vue?vue&type=script&lang=js"

import "./CorporateGovernance.vue?vue&type=style&index=0&id=27b69fda&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b69fda"]])

export default __exports__